<template>
    <div id="newCalendar">
        <el-calendar  onselectstart="return false">
            <template
                    slot="dateCell"
                    slot-scope="{date, data}"
            >
                <div class="mr8" @click.stop="stop">
                    <div :class="['box',list.findIndex(one=>one==data.day)!=-1?'is-select':'']"
                         @click.stop="stop"
                         @mouseup="upClick(data)"
                         @mousedown="rlClick(data,date)"
                         @mousemove="moveClick(data,date)"
                    >

                        <div class="date center">
                            <!--           @click.stop="doSome"                   {{ data.day.split('-').slice(1).join('-') }} {{ data.day == firstC||data.day== endC||data.isover? '✔️' : ''}}-->
                            {{ data.day.split('-').slice(2).toString() }}

                        </div>
                        <div class="findday">
                            {{ data.day}}
                        </div>
                        <div v-for="(item,index) in leaveDay" v-if="item.date==data.day" class="workday center f14">
                            <div >{{item.leave}}</div>
                        </div>
                        <span v-for="(day,index) in gongXiu" v-if="day.scheduleDate==data.day" :class="['work',day.i_iswork==1?'banColor':'xiuColor']">{{day.i_iswork==1?'班':day.i_iswork==0?'休':''}}</span>
                        <button class="doSome" v-if="data.day==endC&&btnShow&&btnTxt"
                                @mouseup="btnup" @mousedown="doSome">{{btnTxt}}</button>
                        <button class="buka" v-if="data.day==endC&&btnShow&&bkbtnTxt"
                                @mouseup="btnup" @mousedown="buka">去补卡</button>
                    </div>
                </div>


            </template>
        </el-calendar>
    </div>
</template>

<script>
    export default {
        name: "NewCalender",
        components: {},
        props:{
            btnTxt:{
                type:String,
                default:''
            },
            bkbtnTxt:{
                type:String,
                default:''
            },
            kqtc:{
                type:Object,
                default:()=>{},
            },
            leaveDay:{
                type:Array,
                required:true
            },
            gongXiu:{
                type:Array,
                required:true
            },
        },
        data() {
            return {
                clickTime:undefined,
                firstC:'',
                endC:'',
                list:[],
                btnShow:false,
                isCtrl:false,
                isShift:false,
                shiftchoose:[],
            }
        },
        mounted() {
            this.eventlistender()
            let ca=document.getElementById('newCalendar')
            ca.oncontextmenu=function (e) {
                //console.log(e.button,'button')
                return false
            }
            this.getfw();
            let btns=document.getElementsByClassName('el-button-group')[0].children;
            let btn0 = btns[0],
            btn1 = btns[1],
            btn2 = btns[2];
            btn0.addEventListener('click', this.showMsg, false);
            btn1.addEventListener('click', this.showMsg, false);
            btn2.addEventListener('click', this.showMsg, false);
        },
        beforeDestroy(){
            window.removeEventListener('keyup',this.eventlistender)
            window.removeEventListener('keydown',this.eventlistender)
        },
        methods: {
        eventlistender(){
            window.addEventListener('keydown',e=>{
                let e1=e||window.event;
                if(e1.keyCode==17){
                        this.isCtrl=true;
                        e.preventDefault();
                }
            })
            window.addEventListener('keyup',e=>{
                let e1=e||window.event;
                if(e1.keyCode==17){
                    this.isCtrl=false;
                    e.preventDefault();
                }
            })
        },

            getfw(){
                let date=document.getElementsByClassName('findday');
                this.firstd=(date[0].innerHTML).trim();
                this.lastd=(date[date.length-1].innerHTML).trim();
                let dateSE={
                    start:this.firstd,
                    end:this.lastd
                }
                this.$emit('fw',dateSE)
            },
            stop(){},
            prevent(val){
                this.shiftchoose.push(val.day)
                if (this.isCtrl){
                    // console.log(this.isCtrl,'isCtrl')
                    let i=this.list.findIndex(one=>one==val.day)
                    i==-1?this.list.push(val.day):this.list.splice(i,1)
                    let b=this.shiftchoose[this.shiftchoose.length-1];
                    this.shiftchoose=[b];
                }else{
                    // console.log('null')
                    this.list=[]
                    this.list[0]=val.day
                    let a=this.shiftchoose[this.shiftchoose.length-1];
                    this.shiftchoose=[a];
                }
                if (this.list.length>0){this.btnShow=true;this.endC=this.list[this.list.length-1]}
                this.$emit('change',this.list,this.isShift?'shift':'ctrl')

                // console.log(this.isCtrl,this.isShift,'ctrl')
                // console.log(this.list,'this.dateList')
            },
            showMsg(){
                this.getfw();
                this.$emit('changeM');
                this.$emit('dailySituation')
                // console.log(this.firstd,'12',this.lastd)
            },
            doSome(e){
                this.btndown=true;
                this.isCtrl=false;
                e.stopPropagation();
                this.$emit('btnClick','jiabie')
            },
            buka(e){
                this.btndown=true;
                this.isCtrl=false;
                e.stopPropagation();
                this.$emit('btnClick','buka')
            },
            btnup(){
                this.btndown=false
            },
            clearData(){
                this.list=[];
                this.$forceUpdate()
            },

            rlClick(data,date){
                this.btnShow=false
                if (!this.btndown){
                    if (!this.isCtrl){
                        this.list=[]
                    }
                    const { day } = data;
                    this.firstC=day
                    this.canover=true
                }
            },
            upClick(data,date){
                let ctrl=false
                this.canover=false
                this.btnShow=true
                this.endC=data.day
                if (this.isCtrl){
                    ctrl=true
                    let i=this.list.findIndex(one=>one==data.day)
                    i==-1?this.list.push(data.day):this.list.splice(i,1)
                    this.endC=this.list[this.list.length-1]
                    this.list.sort()
                }else{
                    this.overClick()
                }
                ctrl=this.list.length==1?true:ctrl
                // console.log(this.list,'list')
                this.$emit('change',this.list,ctrl?'ctrl':'shift')
            },
            moveClick(data,date){
                if(this.canover&&!this.isCtrl){
                    this.list=[]
                    this.endC=data.day
                    this.overClick()
                }
            },
            overClick() {
                // console.log(this.firstC ,this.endC,'this.firstC > this.endC')
                if (this.firstC > this.endC) [this.firstC, this.endC] = [this.endC, this.firstC]
                let farr = this.firstC.split('-'),
                    earr = this.endC.split('-'),
                    [fy, fm, fd] = farr,
                    [ey, em, ed] = earr;
                this.dstar = false;
                this.mstar = false;
                for (let y = Number(fy); y <= Number(ey); y++) {
                    let mm , premm;
                    if (Number(ey) ==y) {
                        if (this.mstar){
                            premm=1
                            mm=Number(em)
                        }else {
                            premm=Number(fm)
                            mm=Number(em)
                        }
                     }else{
                        mm=12
                        if(this.mstar){premm=1}else{premm=Number(fm)}
                    }
                    for (let m = premm; m <= mm; m++) {
                        if (m ==12) this.mstar = true
                        const ml = [1, 3, 5, 7, 8, 10, 12],mlist = [4, 6, 9, 11];
                        let md , premd;
                        if (Number(em) == m) {
                            if(this.dstar){
                                premd=1;
                                md = Number(ed);
                            }else{
                                md = Number(ed);
                                premd=Number(fd)
                            }
                        }else{
                            if (ml.includes(m)) {
                                md = 31
                            } else if (m == 2) {
                                if (y % 4 == 0)  {md = 29}
                                else md = 28
                            }else if (mlist.includes(m)){
                                md=30
                            }
                            if(this.dstar){premd=1}else{premd=Number(fd)}
                        }
                        for (let d = premd; d <= md; d++) {
                            if (d == md) this.dstar = true
                            let day = `${y}-${m >= 10 ? m : '0' + m}-${d >= 10 ? d : '0' + d}`
                            if (this.list.findIndex(one => one == day) == -1) this.list.push(day)
                        }
                    }

                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .findday{
        visibility: hidden;
    }
    .banColor,.workday{
        color: #000 !important;
    }
    .xiuColor{
        color: red !important;
    }
    .work{
        position: absolute;
        left: 8px;
        top:8px;
        font-size: 12px;
        font-weight: bold;
        opacity: 0.8;
    }
    .doSome{
        position: absolute;
        padding: 5px 14px;
        border-radius: 5px;
        background-color: #f2f2f2;
        border:1px solid #36cb85;
        color: #36cb85;
        right: -30px;
        top: 0px;
        z-index: 99;
    ;
    }
    .buka{
        position: absolute;
        padding: 5px 14px;
        border-radius: 5px;
        background-color: #f2f2f2;
        border:1px solid #df110e;
        color: #df110e;
        right: -30px;
        bottom: 0px;
        z-index: 99;
    }
    /deep/ {
        .el-calendar-day {
            padding: 0;
            /*height: 70px;*/
            /*margin: 4px;*/
            background-color: unset !important;

        }
        .el-calendar-table thead th{
            padding: 2px 0;
        }
        .el-calendar__header{
            padding: 8px 20px;
        }

        .el-calendar-day .box:hover {
            background-color: #f7eae8 !important;
        }

        .el-calendar-day .is-select {
            background-color: #f7eae8 !important;
        }
        .mr8{
            padding: 8px;
        }
        .el-calendar-day .box {
            background-color: #eaf7f5;
            height: 58px;
            padding: 8px;
            /*margin: 8px;*/
            border-radius: 5px;
            position: relative;
        }

        .el-calendar-day .date {
            height: fit-content;
            left: 0;
            top: 0;
            bottom: 0;
            right: 0;
            margin:auto;
            font-size: 50px;
            position: absolute;
            opacity: 0.3;

        }

        .center {
            text-align: center;
        }

        .f14 {
            font-size: 14px;
            font-weight: bold;
        }
        .el-calendar__body  {
            height: 450px;

        }
        .el-calendar-table  {
           height: 100%;

        }
        .el-calendar-table tr td {
            border: none;
            background-color: unset !important;

        }

        .el-calendar-table tr td.is-today {
            color: #67cba9;
        }

        .el-calendar-table__row td:nth-child(7), .el-calendar-table__row td:nth-child(6) {
            /*background-color: #f5f5f5;*/
            color: red;
        }
    }
</style>